import React, { useState, useEffect, useCallback } from 'react';
import ReactQuill from 'react-quill';
import { Box } from '@mui/material';
import 'react-quill/dist/quill.snow.css';

const modules = {
  toolbar: [
    ['bold', 'italic'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
  ],
};

const formats = ['bold', 'italic', 'list', 'bullet', 'link'];

const HtmlEditor = ({ initialValue = '', onChange }) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleChange = useCallback(
    (content) => {
      setValue(content);
      if (onChange) onChange(content);
    },
    [onChange]
  );

  return (
    <Box
      sx={{
        marginBottom: 4,
        position: 'relative',
        '& .ql-container': {
          minHeight: 200,
        },
        '& .ql-tooltip': {
          zIndex: 1500,
          left: '50% !important',
          right: 'auto !important',
          transform: 'translateX(-50%) !important',
        },
      }}
    >
      <ReactQuill
        theme="snow"
        value={value}
        onChange={handleChange}
        modules={modules}
        formats={formats}
      />
    </Box>
  );
};

export default HtmlEditor;
